import { produce } from 'immer'
import {
  POST_ACCESS_CODE_FAILURE,
  POST_ACCESS_CODE_INIT,
  POST_ACCESS_CODE_SUCCESS,
  PostAccessCodeActions,
} from 'src/app/CspUserDetail/redux/cspUserDetail.actions'

export interface CspUserDetailState {
  postingAccessCode: boolean
  hasCreatedAccessCode: boolean
}

export const initialState: CspUserDetailState = {
  postingAccessCode: false,
  hasCreatedAccessCode: false,
}

export type Actions = PostAccessCodeActions

const CspUserDetailReducer = (
  state = initialState,
  action: Actions,
): CspUserDetailState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_ACCESS_CODE_INIT: {
        draft.postingAccessCode = true
        draft.hasCreatedAccessCode = false
        return draft
      }

      case POST_ACCESS_CODE_SUCCESS: {
        draft.postingAccessCode = false
        draft.hasCreatedAccessCode = true
        return draft
      }

      case POST_ACCESS_CODE_FAILURE: {
        draft.postingAccessCode = false
        draft.hasCreatedAccessCode = false
        return draft
      }
    }
  })
}

export default CspUserDetailReducer
